
export default {
  name: 'Certification',
}
